import React from "react";
import { Card, CardContent } from "@/components/ui/card";

// Displays ONLY: ref, document_title, chunk_index, score, snippet_text
export default function CitationCard({ citation }) {
  const scoreStr = Number.isFinite(citation?.score) ? citation.score.toFixed(3) : "—";
  return (
    <Card
      data-testid="assistant-citation-card"
      className="border border-black/10"
    >
      <CardContent className="p-4">
        <div className="flex items-center justify-between gap-2 mb-2">
          <div className="text-xs font-mono uppercase tracking-widest text-[#0B4DCC]">
            {citation.ref}
          </div>
          <div className="text-xs text-neutral-500">
            chunk index: {citation.chunk_index} · score {scoreStr}
          </div>
        </div>
        <div className="text-sm font-medium text-[#0B1F3A] truncate">
          {citation.document_title}
        </div>
        <blockquote className="mt-2 text-sm text-neutral-700 border-l-2 border-[#0B4DCC] pl-3 whitespace-pre-wrap">
          {citation.snippet_text}
        </blockquote>
      </CardContent>
    </Card>
  );
}
